import ko from 'knockout';
import Backbone from 'backbone';
import template from '@bingads-webui-campaign-legacy/auto-targets/template/create/radiogroup.pug';
import ViewModel from '@bingads-webui-campaign-legacy/auto-targets/viewmodel/create/radiogroup';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');

export default class DropdownView extends Backbone.View {
  initialize(options = {}) {
    this.viewmodel = new ViewModel(options);
    this.on('update:setting', (setting) => {
      this.viewmodel.setting(setting);
    });
    this.viewmodel.radiogroup.subscribe((radios) => {
      this.trigger('change:radiogroup', radios);
    });
  }

  render() {
    this.$el.html(template({ learnMore: i18n.get('Learn_more_link_text') }));
    ko.applyBindings(this.viewmodel, this.el);
    return this;
  }
}
